import React, { useState } from 'react';
import { CalendarClock, X } from 'lucide-react';

// ⚙️ Modifier ces valeurs pour mettre à jour le message
export const VACATION_CONFIG = {
  enabled: false,
  endDate: '18 août 2026',
  resumeDate: '20 août 2026',
  message: 'Nos expéditions reprennent le 20/08/2026.',
  subMessage: 'Les commandes passées durant cette période seront traitées à notre retour.',
};

export default function VacationBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (!VACATION_CONFIG.enabled || dismissed) return null;

  return (
    <div className="bg-gradient-to-r from-orange-500 to-amber-500 text-white">
      <div className="max-w-screen-xl mx-auto px-3 py-2 flex items-center gap-2.5 text-xs sm:text-sm">
        <CalendarClock className="w-4 h-4 shrink-0" />
        <p className="flex-1 leading-tight">
          <span className="font-bold">⚠️ En vacances jusqu'au {VACATION_CONFIG.endDate}.</span>{' '}
          <span className="hidden sm:inline">{VACATION_CONFIG.message} {VACATION_CONFIG.subMessage}</span>
          <span className="sm:hidden">{VACATION_CONFIG.message}</span>
        </p>
        <button
          onClick={() => setDismissed(true)}
          aria-label="Fermer l'avertissement"
          className="p-1 rounded hover:bg-white/20 transition-colors shrink-0"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}